import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import  {Provider} from "react-redux"
import store from "./redux-setup/store";
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </Provider>
);